export default function copyToClipboard(text) {
    const selection = document.createElement('div');
    selection.setAttribute('contentEditable', true);
    selection.innerText = text;
    document.body.appendChild(selection);
    window.getSelection().selectAllChildren(selection);
    document.execCommand('copy');
    document.body.removeChild(selection);
}
